<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      Fast Invoice {{ new Date().getFullYear() }} |
      <b-link
        class="ml-25"
        href="https://fastinvoice.me"
        target="_blank"
      >fastinvoice.me</b-link>
      <span class="d-none d-sm-inline-block" />
    </span>

    <span class="float-md-right d-none d-md-block">
      <feather-icon
        v-if="true==false"
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
